import React, { useState } from 'react';
import { useSurveyResponses } from '../../Hooks/Features/SurveyManagement/useSurveyResponses';
import { dateConvert } from '../../utils/Helper';
import QuestionBank from '../../pages/Features/QuestionBank/QuestionBank';
import { Dialog } from 'primereact/dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from "underscore"
import { Dropdown } from 'primereact/dropdown';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { MultiSelect } from 'primereact/multiselect';
import CommonGrid from '../CommonCompo/CommonGrid/CommonGrid';
import ViewResponse from './ViewResponse';
import { IconButton } from '@mui/material';

const SurveyResponse = () => {

    const { loader, data, state, showCreateSurvey, surveyQuestions, setSurveyQuestions, filterValue, setFilterValue, options, getSurveyInfoDetails, columns, surveyStats, viewResponse, setViewResponse } = useSurveyResponses();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

    return (
        <div>
            <div className='d-flex align-items-center justify-content-between px-2 shadow-sm m-2 border rounded'>
                <div className='d-flex px-2'>
                    <div className='my-2 p-1 px-3 border-end'><span className='text-muted fw-semibold'>Survey Name:</span> <b>{state?.surveyData?.survey_name}</b></div>
                    <div className='my-2 p-1 px-3 border-end'>
                        <span className='text-muted fw-semibold'>Survey status:</span> <b className={`text-capitalize border px-1 rounded ${state?.surveyData?.survey_status === 'completed' || state?.surveyData?.survey_status === 'active' ? 'text-success border-success' :
                            state?.surveyData?.survey_status === 'pending' ? 'text-warning border-warning' :
                                state?.surveyData?.survey_status === 'rejected' ? 'text-danger border-danger' :
                                    'text-secondary border-secondary'
                            }`}>
                            {state?.surveyData?.survey_status}
                        </b>
                    </div>
                    <div className='my-2 p-1 px-3 border-end'><span className='text-muted fw-semibold'>Survey type:</span> <b>{state?.surveyData?.survey_type_name}</b></div>
                    <div className='my-2 p-1 px-3 border-end'><span className='text-muted fw-semibold'>Timeline:</span> <b>{dateConvert(state?.surveyData?.start_datetime, "date-time-months")} - {dateConvert(state?.surveyData?.end_datetime, "date-time-months")}</b></div>
                    <div className='my-2 p-1 px-3 border-end'><span className='text-muted fw-semibold'>Questions:</span> <b className='c-pointer text-decoration-underline' onClick={() => setSurveyQuestions((prev) => ({ ...prev, show: true }))}>{!_.isEmpty(surveyQuestions?.selected) && Object.keys(surveyQuestions?.selected?.questions)?.length}</b></div>
                </div>

                <div className='d-flex gap-2'>
                    {
                        filterValue?.viewfield && <div className='d-flex gap-2 align-items-center justify-content-end'>
                            <div>
                                <input type='text' placeholder='Username' className='sk-input-dd mb-0 w100' value={filterValue?.username} onChange={(e) => setFilterValue((prev) => ({ ...prev, username: e.target?.value }))} autoComplete='off' />
                            </div>
                            <div className="input-set mx-0">
                                <div className="position-relative">
                                    <input
                                        value={filterValue?.password}
                                        onChange={(e) => setFilterValue((prev) => ({ ...prev, password: e.target.value }))}
                                        type={filterValue?.showPassword ? "text" : "password"}
                                        className="w100 sk-input-dd mb-0 w100"
                                        name="password"
                                        placeholder='Password'
                                        autoComplete='new-password'
                                    />
                                    <IconButton
                                        style={{ position: "absolute", top: "8px", right: "10px" }}
                                        aria-label="toggle password visibility"
                                        onClick={() => setFilterValue((prev) => ({ ...prev, showPassword: !prev?.showPassword }))}
                                    >
                                        {filterValue?.showPassword ? (
                                            <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                        ) : (
                                            <FontAwesomeIcon icon="fa-solid fa-eye" />
                                        )}
                                    </IconButton>
                                </div>
                            </div>
                            <button className='sk-btn bg-black text-white sk-btn-primary' onClick={() => getSurveyInfoDetails()}><FontAwesomeIcon icon="fa-solid fa-check" /></button>
                        </div>
                    }
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValue((prev) => ({ ...prev, viewfield: !prev?.viewfield }))} ><FontAwesomeIcon icon="fa-solid fa-lock" /></button>
                    <button className='sk-btn sk-btn-primary' onClick={() => setShowFiltersDrawer(true)}>
                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                    </button>
                    <button title='Refresh' className="sk-btn sk-btn-primary" onClick={getSurveyInfoDetails}><FontAwesomeIcon icon="fa-solid fa-refresh" /></button>
                </div>
            </div>

            <div className="row px-0 mx-0">
                {surveyStats?.map((stat, index) => (
                    <div className=' col-md-2 col-6'>
                        <div
                            key={index}
                            className={`p-3 c-pointer rounded border text-left shadow-sm ${filterValue?.status === stat?.value
                                ? "bg-primary text-white"
                                : " border text-muted"
                                }`}
                            onClick={() => { setFilterValue((prev) => ({ ...prev, status: stat?.value }));getSurveyInfoDetails("status",stat?.value) }}
                        >
                            <div className="d-flex align-items-center gap-2 mb-1">
                                <FontAwesomeIcon
                                    icon={`fa-solid ${stat.icon}`}
                                    className={`w-4 h-4 ${filterValue?.status === stat?.value ? "text-white" : "text-muted"}`}
                                />
                                <span className={` ${filterValue?.status === stat?.value ? "text-white" : "text-muted"
                                    }`}>
                                    {stat.label}
                                </span>
                            </div>
                            <p className='fw-bold' style={{ fontSize: "20px" }}>{options?.statusCount?.[stat?.value] || 0}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div>
                <div className="mt-2" style={{ height: "calc(100vh - 200px)", overflowY: "auto", }}>
                    <CommonGrid columns={columns} data={data} expandAll={true} rowHeight={40} headerHeight={40} loader={loader} />
                </div>
            </div>
            <Dialog visible={surveyQuestions?.show} onHide={() => setSurveyQuestions((prev) => ({ ...prev, show: false }))} draggable={false} className='modal-large'
                header={() => {
                    return (
                        <div>Share Survey: "{showCreateSurvey?.edit_survey_name}" <span className='text-danger'>({dateConvert(showCreateSurvey?.data?.survey_details?.[0]?.start_datetime, "date-time-months")} - {dateConvert(showCreateSurvey?.data?.survey_details?.[0]?.end_datetime, "date-time-months")} )</span></div>
                    )
                }}>
                <div className='h-100 w100' style={{ overflowY: "auto", overflowX: "hidden" }}>
                    <QuestionBank surveyQuestions={surveyQuestions?.list} fromComp="direct" disabled={true} questions={surveyQuestions?.selected} />
                </div>
            </Dialog>
            <Dialog visible={viewResponse?.show} onHide={() => setViewResponse((prev) => ({ ...prev, show: false }))} draggable={false} className='modal-large' header={() => <div>Feedback analysis for {viewResponse?.data?.[0]?.target_user} </div>}>
                <ViewResponse viewResponse={viewResponse?.data} />
            </Dialog>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setFilterValue({
                                    ...filterValue,
                                    survey: null,
                                    unit: [],
                                    users: [],
                                    evaluator: [],
                                    group_by: null,
                                    isChange: true
                                });
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Group By Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Group By</div>
                                <Dropdown
                                    placeholder="Group By"
                                    options={options?.group_by || []}
                                    value={filterValue?.group_by}
                                    onChange={(e) => { setFilterValue((prev) => ({ ...prev, group_by: e.target.value, isChange: true })); if (e?.value === undefined) { getSurveyInfoDetails("group") } }}
                                    onHide={() => { if (filterValue?.isChange) getSurveyInfoDetails() }}
                                    showClear
                                    className="sk-input-dd w-100"
                                    filter filterInputAutoFocus />
                            </div>

                            {/* Survey Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Survey</div>
                                <Dropdown
                                    placeholder="Survey"
                                    options={options?.survey_list || []}
                                    value={filterValue?.survey}
                                    optionLabel="survey_name"
                                    optionValue='survey_id'
                                    onChange={(e) => setFilterValue((prev) => ({ ...prev, survey: e.value, isChange: true }))}
                                    className="sk-input-dd w-100"
                                    onHide={() => { if (filterValue?.isChange) getSurveyInfoDetails() }}
                                    filter filterInputAutoFocus
                                />
                            </div>

                            {/* Unit, User, Evaluator Filters */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Dimensions</div>
                                <div className="d-flex flex-column gap-2">
                                    <MultiSelect
                                        placeholder="Unit"
                                        options={options?.units || []}
                                        value={filterValue?.unit}
                                        optionLabel="group_name"
                                        onChange={(e) => setFilterValue((prev) => ({ ...prev, unit: e.target.value, isChange: true }))}
                                        onHide={() => { if (filterValue?.isChange) getSurveyInfoDetails() }}
                                        className="sk-input-dd w-100"
                                        filter filterInputAutoFocus
                                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'unit', filterValue.unit, (val) => setFilterValue((prev) => ({ ...prev, unit: val, isChange: true })), () => { })}
                                    />
                                    <MultiSelect
                                        placeholder="User"
                                        options={options?.users || []}
                                        value={filterValue?.users}
                                        optionLabel="evaluator_user_name"
                                        onChange={(e) => setFilterValue((prev) => ({ ...prev, users: e.value, isChange: true }))}
                                        className="sk-input-dd w-100"
                                        onHide={() => { if (filterValue?.isChange) getSurveyInfoDetails() }}
                                        filter filterInputAutoFocus
                                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'users', filterValue.users, (val) => setFilterValue((prev) => ({ ...prev, users: val, isChange: true })), () => { })}
                                    />
                                    <MultiSelect
                                        placeholder="Evaluator"
                                        options={options?.users || []}
                                        value={filterValue?.evaluator}
                                        optionLabel="evaluator_user_name"
                                        onChange={(e) => setFilterValue((prev) => ({ ...prev, evaluator: e.value, isChange: true }))}
                                        onHide={() => { if (filterValue?.isChange) getSurveyInfoDetails() }}
                                        className="sk-input-dd w-100"
                                        filter filterInputAutoFocus
                                        panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'evaluator', filterValue.evaluator, (val) => setFilterValue((prev) => ({ ...prev, evaluator: val, isChange: true })), () => { })}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            getSurveyInfoDetails();
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SurveyResponse
